import Loader from '@/components/loader';
import { Box } from '@mui/material';
import { FC } from 'react';

type Props = {
  label: string;
  isLoading?: boolean;
};

const CountLabel: FC<Props> = ({ label, isLoading = false }) => {
  return (
    <>
      {isLoading ? (
        <Box px={1} width="100px">
          <Loader />
        </Box>
      ) : (
        <Box borderRight="1px solid" borderColor="divider" pr={1}>
          {label}
        </Box>
      )}
    </>
  );
};

export default CountLabel;
